import React from 'react';
import { Box, Container, Text } from '@chakra-ui/react';
import CareersHero from '../components/CareersComponents/CareersHero';
import MostDemandingCategories from '../components/CareersComponents/MostDemandingCategories';
import JobSecureSection from '../components/CareersComponents/JobSecureSection';
import JoinUsSection from '../components/CareersComponents/JoinUsSection';
import SubscribeJobAnnouncement from '../components/CareersComponents/SubscribeJobAnnouncement';
import FAQSection from '../components/CareersComponents/FAQSection';
import CareersFooter from '../components/CareersComponents/CareersFooter';

const Careers = () => {
  return (
    <Box bg="gray.50" minH="100vh">
      <CareersHero />
      <Container maxW="7xl" px={{ base: 2, md: 4, lg: 6 }}>
        <Box py={{ base: 6, md: 8, lg: 10 }} px={{ base: 4, md: 6, lg: 8 }}>
          <Box maxW="7xl" mx="auto" textAlign="center">
            <Text
              fontSize={{ base: "xl", sm: "2xl", md: "3xl", lg: "4xl" }}
              fontWeight="bold"
              color="#244034"
              mb={{ base: 3, md: 4, lg: 6 }}
              lineHeight="1.2"
              px={{ base: 2, md: 0 }}
            >
              Let's Connect — We're Here to Help
            </Text>
            <Text
              fontSize={{ base: "sm", sm: "md", md: "lg", lg: "xl" }}
              color="gray.600"
              lineHeight="tall"
              px={{ base: 2, sm: 4, md: 0 }}
              maxW={{ base: "100%", md: "90%", lg: "90%" }}
              mx="auto"
            >
              At Business Automation, we believe that great technology begins with great people. Behind every
              innovation, every solution, and every breakthrough is a passionate team of problem-solvers, dreamers,
              and builders. We are proud of our diverse, multidisciplinary team—a dynamic mix of seasoned
              professionals, ambitious young talents and an increasing number of women.
            </Text>
          </Box>
        </Box>
        <MostDemandingCategories />
        <JobSecureSection />
        <JoinUsSection />
      </Container>
      {/* <SubscribeJobAnnouncement /> */}
      <FAQSection />
      <CareersFooter />
    </Box>
  );
};

export default Careers;
